// extracted by mini-css-extract-plugin
export default {"toggle":"toggle__3ZWe_","showOnHover":"showOnHover__Dh1Jp","hideOnHover":"hideOnHover__3ovo5","animation":"animation__JEhop","pulse":"pulse__2NTQF"};